import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Constants } from '@shared';
import { Button } from '@common';

const ResendWelcomeInfo = () => {

    const location = useLocation(), navigate = useNavigate();
    const { state: { email } } = location;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col w-full">
            <div className="border-b border-neutral-100 pb-6 mb-6 md:mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                    Check Your Email
                </h1>
            </div>
            <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px] mb-8">
                If we have an account for {email}, we’ll send an email to create your Sunbound account.
            </p>
            <div className="flex flex-col gap-4 items-center w-full">
                <Button
                    variant="primary"
                    size="lg"
                    className="w-full"
                    onClick={() => navigate(`/login`)}
                >
                    Back to Login
                </Button>
                <a
                    href={Constants.Help.FAQ}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-text-base btn-variant-link btn-link-sm">
                    FAQ and Support
                </a>
            </div>
        </div>
    );
};

export default ResendWelcomeInfo;
